import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['clicker', 'menu', 'subMenu']

  connect() {
    this.body = document.body
    this.active = false
  }

  open(event) {
    if ( !this.active ) {
      this.body.classList.add('mobile-menu-body')
      this.clickerTarget.innerHTML = `<i class='bi bi-x-lg'></i>`
      this.active = true
      this.menuTarget.classList.add('active')
    } else {
      this.body.classList.remove('mobile-menu-body')
      this.clickerTarget.innerHTML = `<i class="bi bi-list"></i>`
      this.active = false
      this.subMenuTargets.forEach(m => m.classList.remove('active'))
      setTimeout(() => {
        this.menuTarget.classList.remove('active')
      }, 500)
    }
  }

  openSubMenu(event) {
    let subMenuId = event.params.key
    let menu = this.element.querySelector(`#${subMenuId}`)
    if ( menu ) {
      menu.classList.add('active')
    }
  }

  closeSubMenu(event) {
    let subMenuId = event.params.key
    let menu = this.element.querySelector(`#${subMenuId}`)
    if ( menu ) {
      menu.classList.remove('active')
    }
  }

}
